enum Stage {
  Playground = "playground",
  Development = "dev",
  Staging = "staging",
  Production = "prod",
}

export default Stage;
